import { useGetMySummary } from "@/api/user/useGetMySummary";
import { Error } from "@/components/Error";
import { Center, Loader, Stack, Text } from "@mantine/core";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

type Props = {};

/**
 * This is the page that handles the oauth redirect from the kakao login page
 * it checks the current user's state and then redirects to the relevant user page (home or personality test)
 */
export default function OauthRedirect({}: Props) {
  const { isSuccess, data: userSummary, isError } = useGetMySummary({ enabled: true });
  const posthog = usePostHog();

  // A returning Kakao user (already completed signup) landing here is a login, not a signup.
  useEffect(() => {
    if (isSuccess && userSummary?.hasCompletedSignupFlow) {
      posthog.capture("user_logged_in", { method: "kakao" });
    }
  }, [isSuccess, userSummary?.hasCompletedSignupFlow]);

  if (isSuccess) {
    if (!userSummary.hasCompletedPersonalityTest) {
      return <Navigate to="/personality-test" />;
    }
    if (!userSummary.hasCompletedSignupFlow) {
      return <Navigate to="/signup/kakao" />;
    }

    return <Navigate to="/home" />;
  }

  if (isError) {
    return <Error errorMessage="Error syncing user profile in oauth redirect page" />;
  }

  return (
    <Center style={{ height: "100vh", width: "100%" }}>
      <Stack align="center">
        <Loader />
        <Text>리디렉션 중...</Text>
      </Stack>
    </Center>
  );
}
